import React from 'react';

const StatsTable = () => {
  return <div>StatsTable</div>;
};

export default StatsTable;
